import Vue from "vue";
import Content from "@/components/elements/content.vue";
import Subtitle from "@/components/elements/subtitle.vue";

Vue.component("Content", Content);
Vue.component("Subtitle", Subtitle);
